import React from 'react';
import { Wifi, Cpu, Zap } from 'lucide-react';
export function ControlsAutomationSection() {
  const features = [{
    icon: Cpu,
    title: 'Aerial + Pavement Sensors',
    description: "Our systems don't guess. Advanced sensors detect both moisture AND temperature, ensuring the heat only turns on when it's actually snowing and sticking."
  }, {
    icon: Wifi,
    title: 'WiFi Remote Control',
    description: 'Monitor your system from anywhere. Turn it on manually if you expect a drift, or check its status from your warm living room via smartphone app.'
  }, {
    icon: Zap,
    title: 'Smart Energy Management',
    description: "The controller modulates heat output. It doesn't just blast 100% power; it uses exactly what's needed to keep the surface clear, saving you money."
  }];
  return <section className="py-16 bg-white md:py-24" data-id="element-982">
      <div className="container mx-auto px-4 md:px-6" data-id="element-983">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-984">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-985">
            Smart Controls That Save You Money
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-986">
            The biggest fear homeowners have is "will it run all winter and cost
            a fortune?" The answer is no—because the controls are smarter than
            that.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-987">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center p-6 rounded-xl bg-slate-50 border border-slate-100 hover:border-primary/20 hover:shadow-lg transition-all duration-300" data-id="element-988">
              <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-6 text-primary" data-id="element-989">
                <feature.icon className="h-7 w-7" data-id="element-990" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-991">
                {feature.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-992">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}